import React from 'react'
import ButtonOutlined from 'components/ButtonOutlined'
import ProductCardLikeAndDislikeButtons from 'components/ProductCard/components/LikeAndDislikeButtons'

const OUT_OF_STOCK = 'Out of Stock'

/**
 *
 * @param {ProductCollectionItemButtonProps} props
 * @constructor
 */
const ProductCollectionItemButton = ({
  disabled,
  iconElement,
  isDisabled,
  label,
  needsToBeRatedSample,
  onClickToPass,
  productId,
  productVariant,
  variantId,
  handleOpenAddFullSizeModal,
  shouldShowOutOfStockLabel
}) => {
  if (needsToBeRatedSample) {
    return (
      <ProductCardLikeAndDislikeButtons
        variantId={variantId}
        productId={productId}
        productVariant={productVariant}
        openAddFullSizeModal={handleOpenAddFullSizeModal}
      />
    )
  }

  return (
    <ButtonOutlined
      className='product-collection-item-add'
      onClick={onClickToPass}
      disabled={isDisabled ? true : disabled}
    >
      {iconElement}
      {shouldShowOutOfStockLabel ? OUT_OF_STOCK : label}
    </ButtonOutlined>
  )
}

export default ProductCollectionItemButton
